var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"security-user-detail-container"},[_c('base-header',_vm._b({on:{"handleDelete":_vm.handleHeaderDelete}},'base-header',_vm.headers,false)),_c('base-form',_vm._b({attrs:{"options":{
      contentSecurityOptions: _vm.contentSecurityOptions,
      accessorySecurityOptions: _vm.accessorySecurityOptions
    },"rules":_vm.rules},on:{"handleConfirm":_vm.handleConfirm}},'base-form',_vm.form,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }